module.exports = __webpack_public_path__ + "img/orderedList.14fe3809.svg";